export default __webpack_public_path__ + "static/media/Eye-Win-Left.6957420b.gif";